module.exports = __webpack_public_path__ + "static/media/north.4170dc27.png";